import { IconRatingStar } from "@repo/assets/images";
import { ReviewsCountButton } from "@repo/components";
import { getProductReviews } from "@repo/server-actions/product";
import { getTranslations } from "next-intl/server";
const ReviewsCount = async ({
  itemId,
  averageRating
}) => {
  const t = await getTranslations("Common");
  const reviews = await getProductReviews(itemId);
  const {
    totalElements,
    content
  } = reviews;
  if (content?.length === 0) return;
  return <div className="mb-3 flex items-end space-x-3 rtl:space-x-reverse" data-sentry-component="ReviewsCount" data-sentry-source-file="ReviewsCount.jsx">
      {averageRating && <div className="flex items-center justify-center space-x-3 rtl:space-x-reverse">
          <IconRatingStar className="text-productDetails-reviewStar" />
          <span className="text-productDetails-text text-base font-semibold">
            {/* toFixed is used because JS trims trailing zeros after decimal, for example 3.0 */}
            {averageRating.toFixed(1)}
          </span>
        </div>}
      <ReviewsCountButton totalElements={totalElements} data-sentry-element="ReviewsCountButton" data-sentry-source-file="ReviewsCount.jsx" />
    </div>;
};
export default ReviewsCount;